//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const wordText_fr = `agréable
ardeur
armoire
balle
belge
bonjour
bordure
bouton
cahier
calcul
chanson
charbon
charge
chien
cloche
coin
comme
contre
couleur
coupe
crime
cuivre
diable
dictée
directeur
double
ferme
figure
fromage
grand
jouer
lait
large
lire
liste
main
matinée
meuble
mouton
nuage
oncle
parent
père
perle
piste
planche
plumier
poche
prison
produire
rage
ramage
reine
remarque
reproche
revoir
revue
roi
rose
sac
salutation
singe
sorte
statue
tarte
tous
tout
usage
usine
vapeur
village
ville
voici
ange
autre
aveugle
barque
bec
bille
blancheur
blanchir
bleu
borne
brume
cadre
campagne
canon
chantre
chapeau
chaque
charitable
chef
cochon
contenu
corde
coupable
créature
demain
dent
dernier
dessin
donc
dormir
écharpe
écurie
entier
entretenir
épargne
épine
fauve
fer
finir
fleur
fois
force
fruit
garde
gauche
idée
invisible
jaune
joue
juillet
labeur
lac
larme
lettre
lièvre
linge
liquide
loup
lueur
madame
magique
maître
malin
mercredi
mode
moderne
mot
moteur
murmure
murmurer
nid
nuisible
odeur
papier
pardon
parfait
partie
parvenir
patte
perche
pluie
pondre
porteur
poudre
poule
prendre
proche
profondeur
punir
rare
rat
redevenir
regard
rendre
rien
risque
sabot
sel
signe
singulier
soldat
sueur
surprise
tenue
timide
toile
tombe
tourner
trois
valeur
vase
vaste
vente
véritable
victime
victoire
vide
vif
visible
vite
volume`;

export default wordText_fr;